import { defaultFont } from "./material-kit-react.js"

import tooltip from "./tooltipsStyle.js";

const headerLinksStyle = theme => ({
  list: {
    ...defaultFont,
    fontSize: "14px",
    margin: 0,
    paddingLeft: "0",
    listStyle: "none",
    paddingTop: "0",
    paddingBottom: "0",
    color: "inherit"
    
  },
  listItem: {
    float: "left",
    color: "inherit",
    position: "relative",
  display: "inline-flex",
  alignItems: 'center',
  height: '48px',
    width: "auto",
    margin: "0",
    padding: "0 4px",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      "&:after": {
        width: "calc(100% - 30px)",
        content: '""',
        display: "block",
        height: "1px",
        marginLeft: "15px",
        backgroundColor: "#e5e5e5"
      }
    }
  },
  listItemText: {
    padding: "0 !important"
  },
  navLink: {
    color: "inherit",
    position: "relative",
  padding: "8px 10px",
    fontWeight: "600",
    fontSize: "13px",
    textTransform: "none",
    borderRadius: "8px",
  lineHeight: "18px",
  minHeight: '44px',
    textDecoration: "none",
    margin: "0 3px",
    display: "inline-flex",
    alignItems: 'center',
    gap: 8,
    "&:hover,&:focus": {
  color: "inherit",
      background: "rgba(212,175,55,0.08)",
      transform: 'translateY(-1px)',
      transition: 'all 180ms ease'
    },
    [theme.breakpoints.down("sm")]: {
      width: "calc(100% - 30px)",
      marginLeft: "15px",
      marginBottom: "8px",
      marginTop: "8px",
      textAlign: "left",
      "& > span:first-child": {
        justifyContent: "flex-start"
      }
    }
  },
  notificationNavLink: {
    color: "inherit",
    padding: "0.9375rem",
    fontWeight: "500",
    fontSize: "12px",
    textTransform: "uppercase",
    lineHeight: "20px",
    textDecoration: "none",
    margin: "0px",
    display: "inline-flex",
    top: "4px"
  },
  registerNavLink: {
    top: "3px",
    position: "relative",
    fontWeight: "400",
    fontSize: "12px",
    textTransform: "uppercase",
    lineHeight: "20px",
    textDecoration: "none",
    margin: "0px",
    display: "inline-flex"
  },
  navLinkActive: {
    color: "inherit",
    backgroundColor: "rgba(255, 255, 255, 0.1)"
  },
  icons: {
    width: "18px",
    height: "18px",
    marginRight: "2px"
  },
  socialIcons: {
    position: "relative",
    fontSize: "20px !important",
    marginRight: "4px"
  },
  dropdownLink: {
    "&,&:hover,&:focus": {
      color: "inherit",
      textDecoration: "none",
      display: "block",
      padding: "10px 20px"
    }
  },
  ...tooltip,
  marginRight5: {
    marginRight: "5px"
  },
  option: {
    "&:hover,&:focus": {
      background: "rgba(255, 255, 255, 0.06)"
    },
  display: 'flex',
  height: '48px',
    cursor: 'pointer',
    padding: '0 15px',
    borderRadius: '8px',
    alignItems: 'center',
    width: '70px',
  color: '#fff'
  },
  optionUl: {
    zIndex: 3000,
    position: 'absolute',
    padding: '10px',
    marginTop: '10px',
    borderRadius: '8px',
    background: '#0f0f10',
    boxShadow: '0 6px 18px rgba(0,0,0,0.35)',
  },
  toggleDropdown: {
    display: 'flex',
    height: '38px',
    background: 'transparent',
    padding: '6px 8px',
    fontSize: '16px',
    fontWeight: 600,
    borderRadius: '8px',
    alignItems: 'center',
    cursor: 'pointer',
    justifyContent: 'space-between',
    boxShadow: 'none',
    border: `1px solid rgba(255,255,255,0.06)`,
  }
  ,
  goldButton: {
    background: 'linear-gradient(90deg, #FFD369 0%, #D4AF37 100%)',
    color: '#000',
    padding: '8px 12px',
    borderRadius: '10px',
    textTransform: 'none',
    fontWeight: 800,
    boxShadow: '0 8px 28px rgba(212,175,55,0.18)',
    border: '1px solid rgba(255,255,255,0.06)',
    '&:hover': {
      boxShadow: '0 10px 30px rgba(212,175,55,0.24)',
      transform: 'translateY(-2px)'
    }
  }
});

export default headerLinksStyle;
